// prettier-ignore
import { configureStore } from "@reduxjs/toolkit";
import {
  verificationStatusReducer,
  recordStatusReducer,
  employeeCategoryReducer,
  employeeTypeReducer,
  employeeStatusReducer,
  employeeStatsReasonReducer,
  employeeDocumentReducer,
  employmentTypeReducer,
  workingTimeTypeReducer,
  noticePeriodReducer,
  separationTypeReducer,
  separationReasonReducer,
  employeeRecordStatusReducer,
  bloodGroupReducer,
  personalgenderReducer,
  maritalStatusReducer,
  personalTitleReducer,
  relationshipInfoReducer,
  addressInfoReducer,
  documentStatusReducer,
  accountInfoReducer,
  companyHolidayReducer,
  leaveEligibilityReducer,
  leaveTypeReducer,
  leaveStatusReducer,

  //HCM main tables
  personalEmployeeReducer,
  personalDocumentReducer,
  mainEmployeeReducer,
  mainEmploymentReducer,

  //HCM Info tables
  myInfoContactReducer,
  myInfoAddressReducer,
  myInfoBenifitsReducer,
  myInfoAccountReducer,
  myInfoPassportReducer,
  nomineeInfoReducer,
  dependentDetailsReducer,
  qualificationDetailsReducer,
  professionalDetailsReducer,
  awardDetailsReducer,
  certificationDetailsReducer,
  documentDetailsReducer,
  myProjectReducer,
  holidayReducer,

  leaveManagementReducer,
  leaveTransactionReducer,
   leaveEligibilityMainReducer
} from "@slice";

// ===========================================================================================
export const store = configureStore({
  reducer: {
    myProject: myProjectReducer,
    //hcm

    verificationStatus: verificationStatusReducer,
    recordStatus: recordStatusReducer,
    employeeCategory: employeeCategoryReducer,
    employeeType: employeeTypeReducer,
    employeeStatus: employeeStatusReducer,
    employeeStatusReason: employeeStatsReasonReducer,
    employeeDocuments: employeeDocumentReducer,
    workingTimeType: workingTimeTypeReducer,
    employmentType: employmentTypeReducer,
    employeeRecordStatus: employeeRecordStatusReducer,
    noticePeriod: noticePeriodReducer,
    separationType: separationTypeReducer,
    separationReason: separationReasonReducer,

    companyHoliday: companyHolidayReducer,
    holiday: holidayReducer,
    leaveEligibility: leaveEligibilityReducer,
    leaveType: leaveTypeReducer,
    leaveStatus: leaveStatusReducer,

    relationshipInfo: relationshipInfoReducer,
    addressInfo: addressInfoReducer,
    documentStatus: documentStatusReducer,
    accountInfo: accountInfoReducer,

    //hcm platform
    personalBloodGroup: bloodGroupReducer,
    personalgender: personalgenderReducer,
    personalmaritalStatus: maritalStatusReducer,
    personalTitle: personalTitleReducer,

    //my-info
    myInfoContacts: myInfoContactReducer,
    myInfoAddress: myInfoAddressReducer,
    myInfoBenifits: myInfoBenifitsReducer,
    myInfoAccount: myInfoAccountReducer,
    myInfoPassport: myInfoPassportReducer,
    dependentDetails: dependentDetailsReducer,
    nomineeDetails: nomineeInfoReducer,

    //hcm personal-employee
    personalEmployee: personalEmployeeReducer,
    personalDocument: personalDocumentReducer,
    employees: mainEmployeeReducer,
    employment: mainEmploymentReducer,

    qualificationDetails: qualificationDetailsReducer,
    professionalDetails: professionalDetailsReducer,
    awardDetails: awardDetailsReducer,
    certificationDetails: certificationDetailsReducer,
    documentDetails: documentDetailsReducer,

    //Lms services
    leaveManagement: leaveManagementReducer,
    leaveTransaction: leaveTransactionReducer,
   LeaveEligibilityMain:  leaveEligibilityMainReducer,

    //
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
